import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import Detail from "../../components/Details";
import SpinnerDot from "../../components/SpinnerDot";
import PurchaseForm from "../../forms/PurchaseForm";

export default function Purchase() {
  const { id } = useParams();

  const { data: product } = useQuery(`part-${id}`, () =>
    fetch(`${process.env.REACT_APP_SERVER_ENDPOINT}/parts/${id}`).then((res) =>
      res.json()
    )
  );

  return (
    <main className="max-w-[992px] mx-auto py-8">
      {!product ? (
        <SpinnerDot />
      ) : (
        (() => {
          const { name, imgUrl, description, minQuantity, quantity, price } =
            product;

          return (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center justify-center">
              <section className="mx-auto">
                <div class="card w-96 bg-base-100 shadow-xl">
                  <div class="card-body">
                    <h1 class="card-title text-3xl">{name}</h1>
                    <p>{description}</p>
                  </div>

                  <div className="text-center -mt-4 mb-4">
                    <Detail name="Min Quantity" value={minQuantity} />
                    <Detail name="Available Quntity" value={quantity} />
                    <Detail name="Price" value={`$${price}`} />
                  </div>

                  <figure>
                    <img src={imgUrl} alt="Shoes" />
                  </figure>
                </div>
              </section>

              <section>
                <PurchaseForm product={product} />
              </section>
            </div>
          );
        })()
      )}
    </main>
  );
}
